<template>
  <div class="more-login">
    <label class="title">{{ $t('ai.k_023001') }}</label>
    <vh-button type="text" @click="handleWxworkLogin">
      <img class="wxwork-img" src="../images/wxwork.png" />
    </vh-button>
  </div>
</template>
<script>
  import to from 'await-to-js';

  export default {
    name: 'MoreLogin',
    methods: {
      async handleWxworkLogin() {
        const params = {
          scope: 'snsapi_base',
          redirect_url: `${process.env.VUE_APP_WEB_BASE_URL}/v3/saas-web-ai/embed/wxwork/material`
        };
        const [err, result] = await to(this.$fetch('wxworkAuthorize', params));
        if (err || !result || result.code != 200 || !result.data) {
          this.$vhMessage.error(err?.msg || result?.msg || this.$t('ai.k_023002'));
          return;
        }
        // {
        //   code: 200,
        //   msg: 'success',
        //   data: 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxafd4b7945cbfe3ed&redirect_uri=https%3A%2F%2F35d8aecc.r20.cpolar.top%2Fv1%2Fucenter%2Fapp%2Fcorporation%2Fqw%2Fauthorize%2Fweb%3FredirectUrl%3DdW5kZWZpbmVkL3YzL3NhYXMtd2ViLWFpL2VtYmVkL3d4d29yay9tYXRlcmlhbA%3D%3D&response_type=code&scope=snsapi_base&state=#wechat_redirect',
        //   trace_id: '124ce3e0-e4d5-11ee-8aaf-9d080e3806c7'
        // };
        window.location.href = result.data;
      }
    }
  };
</script>
<style lang="less" scoped>
  .more-login {
    display: flex;
    align-items: center;

    .title {
      color: #777;
      font-size: 14px;
    }
    .wxwork-img {
      width: 40px;
      height: 40px;
      border-radius: 4px;
      margin-left: 20px;
    }
  }
</style>
